// src/pages/IntakeHub/DisabilityPicker.js
import React from 'react';
import { DISABILITY_OPTIONS } from './caseHistoryApi';

/** Multi-select: a child may have more than one disability. */
export default function DisabilityPicker({ value = [], onChange }) {
    const toggle = (option) => {
        onChange(value.includes(option) ? value.filter((v) => v !== option) : [...value, option]);
    };

    return (
        <div className="ih-filters" style={{ marginBottom: 0 }}>
            {DISABILITY_OPTIONS.map((opt) => (
                <button
                    type="button"
                    key={opt.value}
                    className={`ih-chip ${value.includes(opt.value) ? 'active' : ''}`}
                    onClick={() => toggle(opt.value)}
                    aria-pressed={value.includes(opt.value)}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    );
}
